import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import {
  Button,
} from '@folio/stripes/components';
import {
  Pluggable,
} from '@folio/stripes/core';

import css from './user-selection.css';

const UserSelection = ({
  hasAssignCurrent,
  assignCurrentLabelId,
  onCurrentUserSelect,
  onUserSelect,
}) => {
  return (
    <div className={css.pluginContainer}>
      {hasAssignCurrent && (
        <>
          <Button
            data-test-select-current-user
            buttonStyle="link"
            onClick={onCurrentUserSelect}
          >
            <FormattedMessage id={assignCurrentLabelId} />
          </Button>
          <span className={css.delimiter}>
            &#124;
          </span>
        </>
      )}

      <Pluggable
        marginTop0
        aria-haspopup="true"
        id="find-user-button"
        searchButtonStyle="link"
        searchLabel={<FormattedMessage id="ui-task-list.user.lookup" />}
        selectUser={onUserSelect}
        type="find-user"
        visibleColumns={['status', 'name', 'patronGroup', 'username', 'barcode']}
      >
        <span data-test-no-plugin-available>
          <FormattedMessage id="ui-task-list.user.plugin.unavailable" />
        </span>
      </Pluggable>
    </div>
  );
};

UserSelection.propTypes = {
  onUserSelect: PropTypes.func.isRequired,
  assignCurrentLabelId: PropTypes.string,
  hasAssignCurrent: PropTypes.bool,
  onCurrentUserSelect: PropTypes.func,
};

UserSelection.defaultProps = {
  hasAssignCurrent: false,
};

export default UserSelection;
